/** Stable ids shared with VaulDrawer titleId to avoid phantom "Bottom sheet" focus stops. */
export const TAXATION_RULES_HEADING_ID = 'taxation-rules-heading'
export const TAX_GRANDFATHERING_RULE_HEADING_ID = 'tax-grandfathering-rule-heading'
